import { render } from "./Terranova.vue?vue&type=template&id=9485d5ee&scoped=true"
import script from "./Terranova.vue?vue&type=script&lang=js"
export * from "./Terranova.vue?vue&type=script&lang=js"

import "./Terranova.vue?vue&type=style&index=0&id=9485d5ee&scoped=true&lang=css"

import exportComponent from "/Users/desarrollo/Documents/Proyectos/friax/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9485d5ee"]])

export default __exports__